module.exports = __webpack_public_path__ + "static/img/img-co.f15d4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-co.png
// module id = sCcE
// module chunks = 1